export { default as Card } from './card'


// WEBPACK FOOTER //
// ./src/components/card/index.js